import { Currency, BaseCurrencyEquivalentCalculation } from '@/common/types/enums';
import { optionField } from '@/common/utils/form/fieldTypes';

export const system_currency = 'system_currency';
export const base_currency_equivalent_calculation = 'base_currency_equivalent_calculation';

export type BaseCurrencyEquivalentCalculationOption = {
  label: string;
  value: BaseCurrencyEquivalentCalculation;
};

export type AccountingType = {
  [system_currency]: Currency['label'];
  [base_currency_equivalent_calculation]: BaseCurrencyEquivalentCalculation;
};

const config = {
  [system_currency]: optionField(),
  [base_currency_equivalent_calculation]: optionField()
};

export default config;
